import { useTranslation } from '@spcc/core'
import { Clock, cn } from '@spcc/uikit'

import { formatWaitTime } from '../../domain/utils/wait-time'

interface WaitTimeLineProps {
  minutes: number | null | undefined
  isSelected?: boolean
}

/** "~45 min wait now" under a cement type. Renders nothing without an estimate. */
export function WaitTimeLine({ minutes, isSelected }: WaitTimeLineProps) {
  const { t } = useTranslation()
  const label = formatWaitTime(minutes)
  if (!label) return null
  return (
    <div
      className={cn(
        'flex items-center gap-1 mt-0.5 text-xs',
        isSelected ? 'text-primary-foreground/80' : 'text-muted-foreground',
      )}
      title={t('salesOrders.waitHint')}
    >
      <Clock className="w-3 h-3 shrink-0" aria-hidden="true" />
      <span>{t(label.key, label.params)}</span>
    </div>
  )
}
